import BrandSvg from "./BrandSvg";
import { Brand, Center, Header, HeaderContainer, Right } from "./Style";

interface TmpHeaderBaseCustomProps {
    children: React.ReactNode;
    title: string;
}


export default function TmpHeaderBaseCustom(props: TmpHeaderBaseCustomProps) {

    return (
        <Header>
            <HeaderContainer>
                <Brand >
                    <BrandSvg />
                </Brand>
                <Center>
                    {props.title}
                </Center>
                <Right>
                    {props.children}
                </Right>
            </HeaderContainer>
        </Header>
    );
}